var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPictogramBeaconCarRepair40(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 18.6123H35.1773C36.9224 18.6123 38.3371 20.027 38.3371 21.7721V27.3016H5.15975C3.41467 27.3016 2 25.8869 2 24.1419V18.6123Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.8345 26.9063C13.8345 28.8696 12.2429 30.461 10.2801 30.461C8.31674 30.461 6.7251 28.8696 6.7251 26.9063C6.7251 24.943 8.31674 23.3516 10.2801 23.3516C12.2429 23.3516 13.8345 24.943 13.8345 26.9063Z",
    fill: "#FAEC20",
    stroke: "#1E1E1E",
    strokeWidth: 1.1
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.3726 26.9063C34.3726 28.8696 32.781 30.461 30.8182 30.461C28.8548 30.461 27.2632 28.8696 27.2632 26.9063C27.2632 24.943 28.8548 23.3516 30.8182 23.3516C32.781 23.3516 34.3726 24.943 34.3726 26.9063Z",
    fill: "#FAEC20",
    stroke: "#1E1E1E",
    strokeWidth: 1.1
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9536 12.7576C12.4772 12.0647 13.6126 11.5029 14.4863 11.5029H21.9016C22.7767 11.5029 23.9167 12.0727 24.4342 12.7576L28.8581 18.6124H7.52979L11.9536 12.7576Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.1
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8584 18.6126L33.4864 13.9846C33.9843 13.4866 34.7916 13.4867 35.2895 13.9846L35.9678 14.6629",
    stroke: "#1E1E1E",
    strokeWidth: 1.1
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictogramBeaconCarRepair40);
export default __webpack_public_path__ + "static/media/pictogramBeaconCarRepair40.56297f5ea7659674cf6d2ff90163bf62.svg";
export { ForwardRef as ReactComponent };